var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.9734V13.2234H13.5C11.1203 13.2234 8.99124 13.3227 7.13074 14.0253C6.40709 14.2986 5.73298 14.6592 5.10306 15.1281C5.25198 14.8458 5.41552 14.5594 5.59482 14.2734C7.03396 11.9778 9.44998 9.75 13.5 9.75H14.25V9V6.93402L19.8572 11.9805L14.25 16.6905V13.9734Z",
    stroke: "#534FA1",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forwardIcon.bab7c8157147c1c1f71be5d2c872d7fa.svg";
export { ForwardRef as ReactComponent };